export * from './alert.constants';
export * from './user.constants';
export * from './vacanciesForm.constants';
export * from './lang.constants';
export * from './school.constants';
export * from './jobs.constants';
export * from './formApplicant.constants';
export * from './business.profile.constants';
export * from './uploadFile.constants';

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
